<template>
  <div v-if="!loading" class="flex flex-col">
    <div class="flex items-center justify-between mt-4">
      <p class="text-sm text-content-300 max-w-xl">
        Define rangos de peso (en gramos) y el precio de envío que aplica a cada uno.
        El carrito suma el peso de los productos y selecciona el rango que cubre el total.
      </p>
      <router-link
        v-if="hasPermission('edit_shipping_tiers')"
        :to="{ name: 'shippingTiersCreateForm' }"
        class="primary-button mx-0"
      >Nuevo rango</router-link>
    </div>

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white w-full">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Etiqueta</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Rango (gramos)</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Precio</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Activo</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tier in tiers" :key="tier.id" class="table-row">
            <td class="table-cell">{{ tier.label || '—' }}</td>
            <td class="table-cell font-mono text-xs">
              {{ tier.min_grams }}g – {{ tier.max_grams === null ? '∞' : tier.max_grams + 'g' }}
            </td>
            <td class="table-cell">${{ Number(tier.price).toFixed(2) }} MXN</td>
            <td class="table-cell">
              <span v-if="tier.is_active" class="text-green-600 font-semibold">Sí</span>
              <span v-else class="text-content-400">No</span>
            </td>
            <td class="table-cell">
              <div class="flex space-x-2">
                <router-link
                  v-if="hasPermission('edit_shipping_tiers')"
                  :to="{ name: 'shippingTiersEditForm', params: { id: tier.id } }"
                  class="secondary-button"
                >Editar</router-link>
                <button
                  v-if="hasPermission('delete_shipping_tiers')"
                  class="delete-button"
                  @click="confirmDelete(tier)"
                >Eliminar</button>
              </div>
            </td>
          </tr>
          <tr v-if="!tiers.length">
            <td colspan="5" class="text-center p-4 text-content-300">No hay rangos. Crea el primero.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>
  </div>
  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
export default {
  name: "Shipping Weight Tiers",
  data() {
    return { tiers: [], loading: false, loadingDelete: false, tierToDelete: null };
  },
  mixins: [deleteMixin],
  created() {
    this.$store.commit("setStoreSelectedTab", "shippingTiers");
    this.loadTiers();
  },
  methods: {
    async loadTiers() {
      this.loading = true;
      try {
        this.tiers = await api.shippingWeightTiers.getAll();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loading = false;
    },
    confirmDelete(tier) {
      this.tierToDelete = tier;
      this.openDeleteModal();
    },
    async deleteElement() {
      if (!this.tierToDelete) return;
      this.loadingDelete = true;
      try {
        const response = await api.shippingWeightTiers.delete(this.tierToDelete.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.tierToDelete = null;
        await this.loadTiers();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
      this.loadingDelete = false;
    },
  },
};
</script>
